import React from 'react';
import styles from './Button.module.css';

type ButtonProps = {
    label?: string;
    onClick?: () => void;
    disabled?: boolean;
    variant?: 'primary' | 'secondary' | 'ghost' | 'disabled';
    size?: 'small' | 'medium' | 'large';
    noAppearance?: boolean;
    type?: 'button' | 'submit' | 'reset';
    backgroundColor?: string;
    fontColor?: string;
    icon?: React.ReactNode;
    iconPosition?: 'left' | 'right';
};

const Button: React.FC<ButtonProps> = ({
    label = '',
    onClick,
    disabled = false,
    variant = 'primary',
    size,
    noAppearance,
    type = 'button',
    backgroundColor,
    fontColor,
    icon,
    iconPosition = 'right'
}) => (
    <button
        type={type}
        className={`${styles.button} ${styles[variant]} ${noAppearance ? styles.noAppearance : ''} ${size ? styles[size] : ''} ${disabled ? styles.disabled : ''}`}
        onClick={onClick}
        disabled={disabled}
        aria-disabled={disabled}
        style={backgroundColor || fontColor ? { backgroundColor, color: fontColor } : undefined}
    >
        {icon && iconPosition === 'left' && <span className={styles.icon}>{icon}</span>}
        {label}
        {icon && iconPosition === 'right' && <span className={styles.icon}>{icon}</span>}
    </button>
);

export default Button;
